import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';

import { CssPosition } from './css-position.enum';

@Component({
  selector: 'cc-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrl: './loading-spinner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LoadingSpinnerComponent {
  @Input() public position = CssPosition.Fixed;
  public readonly cssPosition = CssPosition;
}
